module.exports = __webpack_public_path__ + "img/login.7a8633a8.png";